﻿import {translation} from "@2d-front-monorepo/core";
import {toggleLoadingDialog} from "@2d-front-monorepo/design-library";
import {PermitId} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback} from "react";
import {useNavigate} from "react-router";
import {reloadPermits} from "../../../contexts/PermitsContext";
import {useHttpClient} from "../../../hooks/useHttpClient";
import {PrivateRoutes} from "../../../routes";

export function SentToReviewComponent({permitId}: { permitId: PermitId }): JSX.Element {
	const navigate = useNavigate();

	const onSubmit = useCallback(async function (): Promise<void> {
		toggleLoadingDialog(true);
		try {
			await useHttpClient().permits.submitForReview(permitId);

		} finally {
			await reloadPermits();
			toggleLoadingDialog(false);
			navigate(PrivateRoutes.permitsList);
		}

	}, [permitId]);

	return <dl className={"title-desc entity-documentation-list--expired col100"}>
		<dt>{translation(PermitTranslations.documentation__expired)}</dt>
		<dd>
			<ol className="entity-documentation-list">
				<li>{translation(PermitTranslations.documentation__updated)}</li>
			</ol>
			<button className="entity-documentation-update form__button form__button--primary form__button--small"
			        onClick={onSubmit}>
				{translation(PermitTranslations.send_for_review)}
			</button>
		</dd>
	</dl>
}
